import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import orderApi from "../../../services/apiServices/orderApi";
import "./SingleOrderPage.css";
import { setLoading } from '../../../services/redux/loadingSlice';
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import CartIcon from "../../../components/icons/CartIcon";
import { useNavigate } from "react-router-dom";
import { putDateOnPattern } from "../../../utils/functions";
import ArrowIcon from "../../../components/icons/ArrowIcon";
import { selectOrderNumber } from "../../../services/redux/authSlice";

const SingleOrderPage = () => {
    const [order, setOrder] = useState(null);
    const [error, setError] = useState(null);
    const { number } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginOrderNumber = useSelector(selectOrderNumber);

    useEffect(() => {
        // Fetch order by its number
        const fetchOrder = async () => {
            dispatch(setLoading(true));
            try {
                const includeParams = { include: 'Customer.User.Address' };
                const response = number
                    ? await orderApi.getOrderByNumber(number, includeParams)
                    : loginOrderNumber
                        ? await orderApi.GetOrderForClientByNumber(loginOrderNumber, includeParams)
                        : await orderApi.GetOrderForClient(includeParams);

                setOrder(response);
            } catch (err) {
                console.error("Error fetching order:", err);
                navigate('/pedidos');
                setError("Erro ao carregar pedido. Tente novamente.");
            }
            finally{
                dispatch(setLoading(false));
            }
        };

        fetchOrder();
    }, [dispatch, navigate, number, loginOrderNumber]);

    if (error) {
        return <p className="error-message">{error}</p>;
    }

    const isExpired = (expirationDate) => {
        return new Date(expirationDate) < new Date();
    };

    if (!order) {
        return <p>Carregando...</p>;
    }

    const items = JSON.parse(order.StItems);

    return (
    <div className="single-order-page">
        <span className="div-center clickable link small-font right-component" onClick={() => navigate('/')}> <ArrowIcon size={12}/> Voltar para a lista de compras</span>
        <PageTitle title="Lista de compras" />
        <div className="order-items">
            <div className="order-item div-with-border padding-default flex-column flex-start">
                <p>Número do pedido: {order.NrOrder}</p>
                <p>Data de criação: {putDateOnPattern(order.Created)}</p>
                <p>Data de expiração: {putDateOnPattern(order.ExpirationDate)}</p>
            </div>

        {items.map((item, index) => (
            <div key={index} className="order-item div-with-border">
                {
                    item.ISBN ? 
                    <img
                        src={`https://pwm-public-product-pro.s3.amazonaws.com/${item.ISBN}-large.webp`}
                        alt="Produto"
                        className="order-item-image"
                    />  
                    :
                    <img
                        src="https://pwm-public-static-pro.s3.amazonaws.com/static/img/no-cover.png"
                        alt="Produto"
                        className="order-item-image"
                    />
                }
                <div className="order-item-details padding-default">
                    <h2 className="order-item-title">{item.Description}</h2>
                    <div className="flex-column gap-default">
                        {
                            item.ISBN ? 
                            <div className="flex-row x-small-font space-between margin-bottom">
                                <p>Cod. ERP: {item.CDERP}</p>
                                <p>ISBN: {item.ISBN}</p>
                            </div>
                            :
                            <div className="x-small-font margin-bottom">
                                <p>Cod. ERP: {item.CDERP}</p>
                            </div>
                        }
                        <p className="order-item-price">R$ {item.UnitPrice.toFixed(2).replace('.', ',')}</p>
                    </div>
                    <div className="order-item-quantity margin-top-default">
                        <label className="quantity-label">Quantidade: {item.Quantity}</label>
                    </div>
                </div>
          </div>
        ))}
        </div>
        <div className="order-summary margin-top-default">
            <h3 className="order-summary-total">
                Total do pedido: R$ {order.VlnetPrice.toFixed(2).replace('.', ',')}
            </h3>
            {
                order.AllowPayment === 1 && !isExpired(order.ExpirationDate) ?
                <button className="main-button" onClick={() => navigate('/pedido/pagamento/' + order.NrOrder)}>
                    <div className="div-inside-button-with-info">
                        <CartIcon color="#FFF"/>
                        <span>Fechar pedido</span>
                    </div>
                </button>
                :
                <button className="main-button" disabled={true}>
                    <div className="div-inside-button-with-info">
                        <CartIcon color="#FFF"/>
                        <span>Pedido não permite pagamento</span>
                    </div>
                </button>
            }
        </div>
    </div>
    );
};

export default SingleOrderPage;